import { gql } from "apollo-boost";

export const UPDATE_INVESTOR = gql`
	mutation updateInvestor($fullName: String!) {
		updateInvestor(input: { fullName: $fullName }) {
			__typename
			... on UpdateInvestorOutput {
				investorID
			}
			... on Error {
				code
				message
			}
		}
	}
`;

export const DELETE_INVESTOR = gql`
	mutation deleteInvestor {
		deleteInvestor {
			__typename
			... on DeleteInvestorOutput {
				investorID
			}
			... on Error {
				code
				message
			}
		}
	}
`;

export const addInvestorAccountByLogin = gql`
	mutation addInvestorAccountByLogin($username: String!, $password: String!) {
		addInvestorAccountByLogin(
			input: { username: $username, password: $password }
		) {
			accountNo
			accountType
		}
	}
`;
export const deleteInvestorAccount = gql`
	mutation deleteInvestorAccount($username: String!) {
		deleteInvestorAccount(input: { username: $username })
	}
`;

export const CREATE_INVESTOR_PASSWORD = gql`
	mutation createInvestorPassword($password: String!, $cfPassword: String!) {
		createInvestorPassword(
			input: { password: $password, cfPassword: $cfPassword }
		) {
			__typename
			... on CreateInvestorPasswordOutput {
				investorID
			}
			... on Error {
				code
				message
			}
		}
	}
`;
